'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

// disable Next prefetch as it doesn't play nicely with CDN
// https://github.com/vercel/next.js/discussions/24437#discussioncomment-3679709
export const PrefetchOverride = () => {
  const router = useRouter();

  useEffect(() => {
    router.prefetch = async () => {};
  }, [router]);

  return null;
};
